export const pushCustomSubmitEvent = formName =>
  window.dataLayer.push({
    event: 'custom_submit_true',
    category: 'custom_submit_true',
    'gtm.elementId': `url: ${window.location.href}; formName: ${formName};`,
  });

export const pushTraineeSubmitEvent = label =>
  window.dataLayer.push({
    event: 'trainee_submit',
    category: 'trainee_submit',
    label,
  });

export const pushMeetupSubmitEvent = () =>
  window.dataLayer.push({
    event: 'meetup_submit_true',
    category: 'meetup_submit_true',
    label: window.location.pathname,
  });

export const pushCookiePolicyEvent = () =>
  window.dataLayer.push({
    event: 'cookie_policy_update',
  });

export const pushCustomEvent = (event, options = {}) => {
  window.dataLayer.push({
    event,
    ...options,
  });
};
